import { api } from '@/shared/api/client';
import type { LoginResponseLike } from '@/shared/auth/storage';

export interface OtpStartResponse {
  SessionId: string;
  ExpiresAt: string;
  DisplayInstruction?: string;
}

export type OtpStatus = 'PENDING' | 'VERIFIED' | 'EXPIRED' | 'FAILED';

export interface OtpStatusResponse {
  SessionStatus: OtpStatus;
}

export function startOtp(phone: string): Promise<OtpStartResponse> {
  return api.post<OtpStartResponse>('/api/sms-otp/start', { Phone: phone });
}

export function pollOtp(sessionId: string): Promise<OtpStatusResponse> {
  return api.get<OtpStatusResponse>(
    '/api/sms-otp/status/' + encodeURIComponent(sessionId),
  );
}

export function phoneLogin(phone: string, sessionId: string): Promise<LoginResponseLike> {
  return api.post<LoginResponseLike>('/api/auth/phone-login', {
    Phone: phone,
    SessionId: sessionId,
  });
}

export function passwordLogin(phone: string, password: string): Promise<LoginResponseLike> {
  return api.post<LoginResponseLike>('/api/auth/password-login', {
    Phone: phone,
    Password: password,
  });
}
